import { CheckCircle } from "@material-ui/icons";
import workinprogress from "../../assets/workinprogrss.png";

const MeetingCard = (props) => {
  const { meetingStatusType, setmeetingStatusType, count, setPage } = props;

  const icons = {
    all: {
      icon: (
        <svg
          width="35"
          height="35"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.375 38.1562C9.84375 40.5469 11.9531 42.2812 14.3906 42.2812C16.8281 42.2812 18.9375 40.5469 19.4063 38.1562L20.2031 34.125C20.625 30.8906 18.1406 27.9844 14.8594 27.9844H14.3906H13.9219C10.6406 27.9844 8.15625 30.8906 8.57812 34.125L9.375 38.1562ZM25.125 45.7969L19.6875 43.875L14.4375 49.125L9.1875 43.875L3.70313 45.7969C3.1875 45.9844 2.8125 46.4062 2.71875 46.9219L0.84375 55.6875H27.9375L26.0625 46.9219C25.9688 46.4062 25.6406 45.9844 25.125 45.7969ZM39.75 34.125L40.5469 38.1562C41.0156 40.5469 43.125 42.2812 45.5625 42.2812C48 42.2812 50.1094 40.5469 50.5781 38.1562L51.375 34.125C51.7969 30.8906 49.3125 27.9844 46.0312 27.9844H45.5625H45.0937C41.8594 27.9844 39.3281 30.8906 39.75 34.125ZM57.2344 46.9219C57.1406 46.4062 56.7656 45.9844 56.25 45.7969L50.8125 43.875H40.3594L34.9219 45.7969C34.4062 45.9844 34.0312 46.4062 33.9375 46.9219L32.0625 55.6875H59.1562L57.2344 46.9219Z"
            fill="#595BD4"
          />
          <path
            d="M16.7809 23.9061L22.0778 22.9218C23.0153 23.8593 24.234 24.5624 25.5465 24.8905C29.6246 26.0155 33.8903 23.4374 34.7809 19.2186C35.6246 15.4218 33.3746 11.5311 29.6246 10.4061C25.8746 9.23427 21.984 11.1561 20.484 14.578C20.3434 14.8593 17.3434 21.2811 16.359 23.3905C16.2184 23.6718 16.4528 23.9999 16.7809 23.9061Z"
            fill="#167FFC"
          />
          <path
            d="M28.6875 8.67171C30 7.03108 32.0625 5.99983 34.3125 6.14046C36.0937 6.23421 37.6875 7.03108 38.8594 8.39046C40.0313 9.70296 40.5938 11.4373 40.5 13.1717C40.4063 14.3436 40.0312 15.5155 39.375 16.4998L39.0938 16.8748L40.875 21.328C39.5625 20.9998 37.6875 20.5311 36.0938 20.1092C35.9062 20.7186 35.6719 21.2811 35.3906 21.8436C37.0312 22.2655 41.4844 23.3905 43.2187 23.8123C43.5 23.9061 43.7812 23.578 43.6406 23.2967L41.1563 17.0623C41.8594 15.8905 42.2344 14.6248 42.3281 13.2655C42.4688 11.0155 41.7188 8.81233 40.2188 7.12483C38.7188 5.43733 36.6563 4.40608 34.4063 4.26546C31.0313 4.07796 28.0312 5.85921 26.4844 8.57796C27.2344 8.57796 27.9375 8.57796 28.6875 8.67171Z"
            fill="#167FFC"
          />
        </svg>
      ),
      count: count?.allMeeting,
      title: "All Meeting",
      type: "all",
    },
    published: {
      icon: (
        <svg
          width="35"
          height="35"
          viewBox="0 0 50 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25 45.5C25.4945 45.5 25.9778 45.3534 26.3889 45.0787C26.8 44.804 27.1205 44.4135 27.3097 43.9567C27.4989 43.4999 27.5484 42.9972 27.452 42.5123C27.3555 42.0273 27.1174 41.5819 26.7678 41.2322C26.4181 40.8826 25.9727 40.6445 25.4877 40.548C25.0028 40.4516 24.5001 40.5011 24.0433 40.6903C23.5865 40.8795 23.196 41.2 22.9213 41.6111C22.6466 42.0222 22.5 42.5055 22.5 43C22.5 43.663 22.7634 44.2989 23.2322 44.7678C23.7011 45.2366 24.337 45.5 25 45.5ZM37.5 45.5C37.9945 45.5 38.4778 45.3534 38.8889 45.0787C39.3 44.804 39.6205 44.4135 39.8097 43.9567C39.9989 43.4999 40.0484 42.9972 39.952 42.5123C39.8555 42.0273 39.6174 41.5819 39.2678 41.2322C38.9181 40.8826 38.4727 40.6445 37.9877 40.548C37.5028 40.4516 37.0001 40.5011 36.5433 40.6903C36.0865 40.8795 35.696 41.2 35.4213 41.6111C35.1466 42.0222 35 42.5055 35 43C35 43.663 35.2634 44.2989 35.7322 44.7678C36.2011 45.2366 36.837 45.5 37.5 45.5ZM37.5 35.5C37.9945 35.5 38.4778 35.3534 38.8889 35.0787C39.3 34.804 39.6205 34.4135 39.8097 33.9567C39.9989 33.4999 40.0484 32.9972 39.952 32.5123C39.8555 32.0273 39.6174 31.5819 39.2678 31.2322C38.9181 30.8826 38.4727 30.6445 37.9877 30.548C37.5028 30.4516 37.0001 30.5011 36.5433 30.6903C36.0865 30.8795 35.696 31.2 35.4213 31.6111C35.1466 32.0222 35 32.5055 35 33C35 33.663 35.2634 34.2989 35.7322 34.7678C36.2011 35.2366 36.837 35.5 37.5 35.5ZM25 35.5C25.4945 35.5 25.9778 35.3534 26.3889 35.0787C26.8 34.804 27.1205 34.4135 27.3097 33.9567C27.4989 33.4999 27.5484 32.9972 27.452 32.5123C27.3555 32.0273 27.1174 31.5819 26.7678 31.2322C26.4181 30.8826 25.9727 30.6445 25.4877 30.548C25.0028 30.4516 24.5001 30.5011 24.0433 30.6903C23.5865 30.8795 23.196 31.2 22.9213 31.6111C22.6466 32.0222 22.5 32.5055 22.5 33C22.5 33.663 22.7634 34.2989 23.2322 34.7678C23.7011 35.2366 24.337 35.5 25 35.5ZM42.5 5.5H40V3C40 2.33696 39.7366 1.70107 39.2678 1.23223C38.7989 0.763392 38.163 0.5 37.5 0.5C36.837 0.5 36.2011 0.763392 35.7322 1.23223C35.2634 1.70107 35 2.33696 35 3V5.5H15V3C15 2.33696 14.7366 1.70107 14.2678 1.23223C13.7989 0.763392 13.163 0.5 12.5 0.5C11.837 0.5 11.2011 0.763392 10.7322 1.23223C10.2634 1.70107 10 2.33696 10 3V5.5H7.5C5.51088 5.5 3.60322 6.29018 2.1967 7.6967C0.790177 9.10322 0 11.0109 0 13V48C0 49.9891 0.790177 51.8968 2.1967 53.3033C3.60322 54.7098 5.51088 55.5 7.5 55.5H42.5C44.4891 55.5 46.3968 54.7098 47.8033 53.3033C49.2098 51.8968 50 49.9891 50 48V13C50 11.0109 49.2098 9.10322 47.8033 7.6967C46.3968 6.29018 44.4891 5.5 42.5 5.5ZM45 48C45 48.663 44.7366 49.2989 44.2678 49.7678C43.7989 50.2366 43.163 50.5 42.5 50.5H7.5C6.83696 50.5 6.20107 50.2366 5.73223 49.7678C5.26339 49.2989 5 48.663 5 48V25.5H45V48ZM45 20.5H5V13C5 12.337 5.26339 11.7011 5.73223 11.2322C6.20107 10.7634 6.83696 10.5 7.5 10.5H10V13C10 13.663 10.2634 14.2989 10.7322 14.7678C11.2011 15.2366 11.837 15.5 12.5 15.5C13.163 15.5 13.7989 15.2366 14.2678 14.7678C14.7366 14.2989 15 13.663 15 13V10.5H35V13C35 13.663 35.2634 14.2989 35.7322 14.7678C36.2011 15.2366 36.837 15.5 37.5 15.5C38.163 15.5 38.7989 15.2366 39.2678 14.7678C39.7366 14.2989 40 13.663 40 13V10.5H42.5C43.163 10.5 43.7989 10.7634 44.2678 11.2322C44.7366 11.7011 45 12.337 45 13V20.5ZM12.5 35.5C12.9945 35.5 13.4778 35.3534 13.8889 35.0787C14.3 34.804 14.6205 34.4135 14.8097 33.9567C14.9989 33.4999 15.0484 32.9972 14.952 32.5123C14.8555 32.0273 14.6174 31.5819 14.2678 31.2322C13.9181 30.8826 13.4727 30.6445 12.9877 30.548C12.5028 30.4516 12.0001 30.5011 11.5433 30.6903C11.0865 30.8795 10.696 31.2 10.4213 31.6111C10.1466 32.0222 10 32.5055 10 33C10 33.663 10.2634 34.2989 10.7322 34.7678C11.2011 35.2366 11.837 35.5 12.5 35.5ZM12.5 45.5C12.9945 45.5 13.4778 45.3534 13.8889 45.0787C14.3 44.804 14.6205 44.4135 14.8097 43.9567C14.9989 43.4999 15.0484 42.9972 14.952 42.5123C14.8555 42.0273 14.6174 41.5819 14.2678 41.2322C13.9181 40.8826 13.4727 40.6445 12.9877 40.548C12.5028 40.4516 12.0001 40.5011 11.5433 40.6903C11.0865 40.8795 10.696 41.2 10.4213 41.6111C10.1466 42.0222 10 42.5055 10 43C10 43.663 10.2634 44.2989 10.7322 44.7678C11.2011 45.2366 11.837 45.5 12.5 45.5Z"
            fill="#595BD4"
          />
        </svg>
      ),
      count: count?.upcomingMeeting,
      title: "Upcoming ",
      type: "upcoming",
    },
    unpublished: {
      icon: workinprogress,
      count: count?.inProgressMeeting,
      title: "Inprogress ",
      type: "inprogress",
    },
    deleted: {
      icon: (
        <svg
          width="35"
          height="35"
          viewBox="0 0 73 73"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M30.415 63.196C27.7676 62.5955 25.2249 61.6021 22.8717 60.2487M42.5831 9.80273C48.6304 11.1839 54.0296 14.5772 57.8968 19.4272C61.764 24.2772 63.87 30.2964 63.87 36.4994C63.87 42.7025 61.764 48.7217 57.8968 53.5717C54.0296 58.4217 48.6304 61.815 42.5831 63.1962M13.9262 51.9916C12.267 49.581 11.0068 46.9189 10.1941 44.1076M9.49902 31.9366C9.98569 29.047 10.9225 26.3095 12.2365 23.8001L12.7506 22.8724M21.0063 13.9272C23.8522 11.9681 27.045 10.5684 30.4141 9.80273M27.3748 36.5005L33.4581 42.5838L45.6248 30.4172"
            stroke="#14A72D"
            stroke-width="5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
      count: count?.completedMeeting,
      title: "Completed ",
      type: "completed",
    },

    cancelled: {
      icon: (
        <svg
          width="35"
          height="35"
          viewBox="0 0 45 45"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.5 13.125H37.5M18.75 20.625V31.875M26.25 20.625V31.875M9.375 13.125L11.25 35.625C11.25 36.6196 11.6451 37.5734 12.3483 38.2766C13.0516 38.9799 14.0054 39.375 15 39.375H30C30.9946 39.375 31.9484 38.9799 32.6516 38.2766C33.3549 37.5734 33.75 36.6196 33.75 35.625L35.625 13.125M16.875 13.125V7.5C16.875 7.00272 17.0725 6.52581 17.4242 6.17417C17.7758 5.82254 18.2527 5.625 18.75 5.625H26.25C26.7473 5.625 27.2242 5.82254 27.5758 6.17417C27.9275 6.52581 28.125 7.00272 28.125 7.5V13.125"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
      count: count?.canceledMeeting,
      title: "Cancelled ",
      type: "cancelled",
    },
  };

  const MeetingCard = ({ icon, title, count, active, type }) => {
    return (
      <div
        className={`card rounded-10p pointer ${active ? "border-success" : ""}`}
        onClick={() => {
          setmeetingStatusType(type);
          setPage(1);
        }}
        style={{
          boxShadow: `${
            active
              ? "rgba(36, 202, 38, 0.4) 0px 1px 2px 0px, rgba(36, 202, 38, 0.15) 0px 2px 6px 2px"
              : "rgba(60, 64, 67, 0.1) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px"
          }`,
        }}
      >
        <div className="card-body">
          <div className="d-flex align-items-center gap-2">
            {typeof icon === "string" ? (
              <img
                src={icon}
                alt="Icon"
                style={{ width: "30px", height: "30px" }}
              />
            ) : (
              icon
            )}
            <div>
              <p
                className={`text-nowrap mb-0 text-poppins h6 ${
                  active ? "text-dark" : "text-secondary"
                }`}
              >
                {title}
              </p>
              <p
                className={`mb-0 text-poppins ${
                  active ? "text-dark" : "text-secondary"
                }`}
              >
                {count}
              </p>
            </div>
            {meetingStatusType === type && (
              <CheckCircle
                style={{
                  color: "rgb(36 202 38)",
                  fontSize: "30px",
                }}
              />
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {Object?.keys(icons)?.map((key) => (
        <div key={key}>
          <MeetingCard
            icon={icons[key]?.icon}
            title={icons[key]?.title}
            count={icons[key]?.count}
            active={meetingStatusType === icons[key]?.type}
            type={icons[key]?.type}
          />
        </div>
      ))}
    </>
  );
};

export default MeetingCard;
